<div class="page-wrapper py-6">
  <div class="container mx-auto px-4 max-w-6xl">
    <div class="mb-6">
      <h3 class="text-2xl font-bold text-base-content">
        Subscribe to Live Class
      </h3>
      <p class="text-sm text-base-content/70 mt-1">
        Select a flexible payment option that best fits your learning schedule.
      </p>
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
      <!-- Course Card Overview -->
      <div class="lg:col-span-5">
        <div class="sticky top-24">
          @if (selectedLiveClass) {
            <black-ui-card [data]="selectedLiveClassCard"></black-ui-card>
          } @else {
            <div class="daisy-card daisy-card-bordered bg-base-100 shadow-sm border-base-300 p-6 animate-pulse">
              <div class="h-48 bg-base-300 rounded-lg mb-4"></div>
              <div class="h-6 bg-base-300 rounded w-3/4 mb-2"></div>
              <div class="h-4 bg-base-300 rounded w-1/2"></div>
            </div>
          }
        </div>
      </div>

      <!-- Payment & Plan Selection -->
      <div class="lg:col-span-7">
        <div
          class="daisy-card daisy-card-bordered bg-base-100 shadow-sm border-base-300 text-base-content"
        >
          @if (selectedLiveClass?.settings; as settings) {
            <div class="daisy-card-body p-6 md:p-8 flex flex-col gap-6">
              @if (hasActiveFullAccessSubscription) {
                <div class="daisy-alert bg-success/10 border border-success/30 text-base-content text-xs py-3.5 px-4 flex items-start gap-3 shadow-sm rounded-box">
                  <div class="w-8 h-8 rounded-full bg-success/20 flex items-center justify-center text-success shrink-0 mt-0.5">
                    <i class="fa-solid fa-crown text-sm"></i>
                  </div>
                  <div class="flex-1">
                    <div class="font-bold text-sm text-base-content">
                      Full Course Access Active
                    </div>
                    <div class="text-base-content/80 text-xs mt-1 leading-relaxed">
                      You already have lifetime full access to this course and all its sessions. No further subscriptions or payments are needed.
                    </div>
                    <div class="mt-3">
                      <a [routerLink]="['/live-classes', selectedLiveClass?.id]" class="daisy-btn daisy-btn-xs daisy-btn-success gap-1.5 shadow-sm">
                        <i class="fa-solid fa-arrow-left"></i>
                        <span>Go to Live Class</span>
                      </a>
                    </div>
                  </div>
                </div>
              } @else if (pendingSubscription) {
                <div class="daisy-alert bg-warning/10 border border-warning/30 text-base-content text-xs py-3.5 px-4 flex items-start gap-3 shadow-sm rounded-box">
                  <div class="w-8 h-8 rounded-full bg-warning/20 flex items-center justify-center text-warning shrink-0 mt-0.5">
                    <i class="fa-solid fa-clock text-sm"></i>
                  </div>
                  <div class="flex-1">
                    <div class="font-bold text-sm text-base-content">
                      Payment Verification Pending
                    </div>
                    <div class="text-base-content/80 text-xs mt-1 leading-relaxed">
                      You already have a payment submitted for this class currently awaiting administrative approval. You do not need to pay again.
                    </div>
                    <div class="mt-3">
                      <a routerLink="/invoices" class="daisy-btn daisy-btn-xs daisy-btn-warning gap-1.5 shadow-sm">
                        <i class="fa-solid fa-receipt"></i>
                        <span>View Invoices</span>
                      </a>
                    </div>
                  </div>
                </div>
              }

              @if (settings.price > 0) {
                <div>
                  <div class="flex items-center justify-between mb-3">
                    <h4 class="font-semibold text-base text-base-content">
                      Choose Payment Option
                    </h4>
                    <span
                      class="daisy-badge daisy-badge-outline text-xs text-base-content/70"
                      >{{ planBadge }}</span
                    >
                  </div>
                  <black-ui-radio-card
                    [options]="paymentOptions"
                    [(selectedIndex)]="selectedPaymentTypeIndex"
                  ></black-ui-radio-card>

                  @if (selectedPaymentTypeIndex === 0 && hasActiveMonthlySubscription) {
                    <div class="mt-4 daisy-alert bg-success/10 border border-success/30 text-base-content text-xs py-3.5 px-4 flex items-start gap-3 shadow-sm rounded-box">
                      <div class="w-8 h-8 rounded-full bg-success/20 flex items-center justify-center text-success shrink-0 mt-0.5">
                        <i class="fa-solid fa-circle-check text-sm"></i>
                      </div>
                      <div class="flex-1">
                        <div class="font-bold text-sm text-base-content">
                          Current Active Subscription
                        </div>
                        <div class="text-base-content/80 text-xs mt-1 leading-relaxed">
                          You are currently subscribed to the Monthly Flexi plan. Your access covers all sessions through
                          <strong>{{ activeMonthlySubscription?.nextPaymentDeadline | date: 'mediumDate' }}</strong>.
                        </div>
                        <div class="mt-3 flex flex-wrap items-center gap-2">
                          <a [routerLink]="['/live-classes', selectedLiveClass?.id]" class="daisy-btn daisy-btn-xs daisy-btn-success gap-1.5 shadow-sm">
                            <i class="fa-solid fa-arrow-left"></i>
                            <span>Go to Class Meetings</span>
                          </a>
                          <a routerLink="/invoices" class="daisy-btn daisy-btn-xs daisy-btn-outline gap-1.5">
                            <i class="fa-solid fa-receipt"></i>
                            <span>View Invoices</span>
                          </a>
                        </div>
                      </div>
                    </div>
                  }

                  @if (selectedPaymentTypeIndex === 1 && hasActiveMonthlySubscription) {
                    <div class="mt-4 daisy-alert bg-primary/10 border border-primary/25 text-base-content text-xs py-3.5 px-4 flex items-start gap-3 shadow-sm rounded-box">
                      <div class="w-8 h-8 rounded-full bg-primary/20 flex items-center justify-center text-primary shrink-0 mt-0.5">
                        <i class="fa-solid fa-arrow-up-right-from-square text-sm"></i>
                      </div>
                      <div class="flex-1">
                        <div class="font-bold text-sm text-base-content">
                          Upgrade to Full Course Access
                        </div>
                        <div class="text-base-content/80 text-xs mt-1 leading-relaxed">
                          Your current month is already paid. Upgrading only bills for the remaining
                          <strong>{{ selectedPaymentPlanData?.totalSessions }} sessions</strong> through course completion and eliminates future monthly renewal invoices.
                        </div>
                      </div>
                    </div>
                  } @else if (upgradeCreditAmount > 0 && selectedPaymentTypeIndex !== 2 && !hasActiveMonthlySubscription) {
                    <div class="mt-4 daisy-alert bg-success/10 border border-success/30 text-base-content text-xs py-3.5 px-4 flex items-start gap-3 shadow-sm rounded-box">
                      <div class="w-8 h-8 rounded-full bg-success/20 flex items-center justify-center text-success shrink-0 mt-0.5">
                        <i class="fa-solid fa-tag text-sm"></i>
                      </div>
                      <div class="flex-1">
                        <div class="font-bold text-sm text-base-content">
                          Single Pass Credit Applied
                        </div>
                        <div class="text-base-content/80 text-xs mt-1 leading-relaxed">
                          You have {{ upgradeCreditSessionsCount }} pre-paid session{{ upgradeCreditSessionsCount === 1 ? '' : 's' }} in this period.
                          <strong>LKR {{ upgradeCreditAmount | number }}</strong> has been automatically credited toward your upgrade!
                        </div>
                      </div>
                    </div>
                  }

                  @if (selectedPaymentTypeIndex === 2) {
                    <div
                      class="mt-4 p-4 rounded-xl bg-base-200/50 border border-base-300"
                    >
                      <label class="daisy-label pt-0">
                        <span
                          class="daisy-label-text font-semibold text-base-content"
                          >Select Class Session</span
                        >
                      </label>
                      @if (upcomingSessions.length > 0) {
                        <select
                          class="daisy-select daisy-select-bordered w-full bg-base-100 text-base-content border-base-300"
                          [ngModel]="selectedSessionIndex"
                          (ngModelChange)="onSessionChange($event)"
                        >
                          @for (session of upcomingSessions; track $index) {
                            <option [value]="$index">
                              {{ session.label }}
                            </option>
                          }
                        </select>
                        @if (selectedSession; as session) {
                          <p class="text-xs text-base-content/60 mt-2">
                            <i
                              class="fa-regular fa-calendar-check mr-1 text-primary"
                            ></i>
                            Session scheduled for
                            {{ session.date | date: 'fullDate' }}
                            @if (session.startTime) {
                              <span
                                >({{ session.startTime }} –
                                {{ session.endTime || 'End' }})</span
                              >
                            }
                          </p>
                        }
                        @if (isCurrentSelectedSessionCovered) {
                          <div class="mt-3 daisy-alert bg-success/10 border border-success/30 text-base-content text-xs py-3 px-3.5 flex items-start gap-2.5 shadow-sm rounded-box">
                            <div class="w-7 h-7 rounded-full bg-success/20 flex items-center justify-center text-success shrink-0 mt-0.5">
                              <i class="fa-solid fa-circle-check text-xs"></i>
                            </div>
                            <div class="flex-1">
                              <div class="font-bold text-sm text-base-content">
                                @if (currentSelectedSessionAccess.accessType === 'MONTHLY') {
                                  Included in Monthly Subscription
                                } @else if (currentSelectedSessionAccess.accessType === 'ONE_TIME') {
                                  Included in Full Course Access
                                } @else {
                                  Pass Already Purchased
                                }
                              </div>
                              <div class="text-base-content/80 text-xs mt-0.5 leading-relaxed">
                                @if (currentSelectedSessionAccess.accessType === 'MONTHLY') {
                                  This session on {{ selectedSession?.date | date: 'fullDate' }} is already covered by your active monthly subscription. You do not need to buy a pass.
                                } @else if (currentSelectedSessionAccess.accessType === 'ONE_TIME') {
                                  You already have full lifetime access to all sessions in this class.
                                } @else {
                                  You already have an active single pass for this session. You do not need to purchase it again.
                                }
                              </div>
                            </div>
                          </div>
                        }
                      } @else {
                        <div
                          class="daisy-alert daisy-alert-warning text-sm py-2"
                        >
                          <i class="fa-solid fa-triangle-exclamation"></i>
                          <span
                            >No upcoming sessions found for this live
                            class.</span
                          >
                        </div>
                      }
                    </div>
                  }
                </div>
              }

              <!-- Detailed Price Breakdown Table -->
              <div class="border-t border-base-300 pt-4">
                <h4 class="font-semibold text-base text-base-content mb-3">
                  Session & Price Breakdown
                </h4>
                <div
                  class="overflow-x-auto rounded-lg border border-base-300 bg-base-100"
                >
                  <table
                    class="daisy-table daisy-table-zebra w-full text-base-content"
                  >
                    <tbody>
                      <tr>
                        <td class="font-medium text-base-content/80">
                          Selected Plan
                        </td>
                        <td class="font-semibold text-right text-base-content">
                          {{ planTitle }}
                        </td>
                      </tr>

                      @if (selectedPaymentTypeIndex === 2) {
                        <!-- Single Class Session Specifics -->
                        <tr>
                          <td class="font-medium text-base-content/80">
                            Target Session
                          </td>
                          <td class="text-right text-base-content">
                            {{ selectedSession?.name || 'Class Session' }}
                          </td>
                        </tr>
                        <tr>
                          <td class="font-medium text-base-content/80">
                            Session Date
                          </td>
                          <td class="text-right text-base-content">
                            {{ selectedSession?.date | date: 'mediumDate' }}
                          </td>
                        </tr>
                        <tr>
                          <td class="font-medium text-base-content/80">
                            Session Time
                          </td>
                          <td class="text-right text-base-content">
                            {{ selectedSession?.startTime || '—' }} –
                            {{ selectedSession?.endTime || '—' }}
                          </td>
                        </tr>
                      } @else {
                        <!-- Monthly / One-Time Specifics -->
                        <tr>
                          <td class="font-medium text-base-content/80">
                            {{
                              selectedPaymentTypeIndex === 0
                                ? 'Billing Cycle Period'
                                : 'Course Duration'
                            }}
                          </td>
                          <td class="text-right text-base-content">
                            {{
                              selectedPaymentPlanData?.startDate
                                | date: 'mediumDate'
                            }}
                            –
                            {{
                              selectedPaymentPlanData?.endDate
                                | date: 'mediumDate'
                            }}
                          </td>
                        </tr>
                      }

                      <tr>
                        <td class="font-medium text-base-content/80">
                          Included Sessions
                        </td>
                        <td class="text-right text-base-content">
                          <button
                            type="button"
                            (click)="openBreakdownModal()"
                            class="daisy-btn daisy-btn-ghost daisy-btn-xs gap-1 text-primary hover:bg-primary/10 border border-primary/20 normal-case px-2.5 py-1 h-auto"
                            title="Click to view session calculation breakdown"
                          >
                            <span class="font-mono font-bold"
                              >{{ selectedPaymentPlanData?.totalSessions }}
                              {{
                                selectedPaymentPlanData?.totalSessions === 1
                                  ? 'session'
                                  : 'sessions'
                              }}</span
                            >
                          </button>
                        </td>
                      </tr>

                      @if (selectedPaymentTypeIndex === 2) {
                        <tr>
                          <td class="font-medium text-base-content/80">
                            Session Rate
                          </td>
                          <td class="text-right text-base-content">
                            @if (effectivePricePerSession > 0) {
                              <span
                                >LKR
                                {{ effectivePricePerSession | number }}</span
                              >
                            } @else {
                              <span class="text-success font-semibold"
                                >Free</span
                              >
                            }
                          </td>
                        </tr>
                      }

                      @if (upgradeCreditAmount > 0 && selectedPaymentTypeIndex !== 2) {
                        <tr class="bg-success/5 border-t border-success/20">
                          <td class="font-medium text-success flex items-center gap-1.5">
                            <i class="fa-solid fa-tag text-xs"></i>
                            <span>Single Pass Credit ({{ upgradeCreditSessionsCount }} session{{ upgradeCreditSessionsCount === 1 ? '' : 's' }})</span>
                          </td>
                          <td class="font-semibold text-right text-success">
                            - LKR {{ upgradeCreditAmount | number }}
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- Billing Plan Note -->
              @if (planNote) {
                <div
                  class="daisy-alert bg-base-200 border-base-300 text-base-content text-xs py-2.5 px-3 flex items-start gap-2.5"
                >
                  <i class="fa-solid fa-circle-info text-primary mt-0.5"></i>
                  <span class="text-base-content/80 leading-relaxed">{{
                    planNote
                  }}</span>
                </div>
              }

              <!-- Grand Total & CTA -->
              @if (selectedPaymentPlanData; as paymentPlan) {
                <div class="border-t border-base-300 pt-4 flex flex-col gap-4">
                  <div class="flex items-center justify-between">
                    <div>
                      <span
                        class="text-xs text-base-content/60 uppercase tracking-wider block"
                        >Total Due Today</span
                      >
                      <span class="text-xs text-base-content/70 font-medium"
                        >All taxes & charges included</span
                      >
                    </div>
                    <div class="text-right">
                      @if (paymentPlan.cost > 0) {
                        <span
                          class="text-2xl md:text-3xl font-bold text-primary"
                        >
                          LKR {{ paymentPlan.cost | number }}
                        </span>
                      } @else {
                        <span class="text-2xl font-bold text-success">
                          Free
                        </span>
                      }
                    </div>
                  </div>

                  @if (hasActiveFullAccessSubscription) {
                    <div class="space-y-2">
                      <a
                        [routerLink]="['/live-classes', selectedLiveClass?.id]"
                        class="daisy-btn daisy-btn-success daisy-btn-block text-base shadow-sm gap-2"
                      >
                        <i class="fa-solid fa-crown"></i>
                        <span>Full Access Active • Go to Live Class</span>
                      </a>
                      <p class="text-xs text-base-content/70 text-center">
                        You own full lifetime access to this class. <a [routerLink]="['/live-classes', selectedLiveClass?.id]" class="daisy-link daisy-link-success font-semibold">View Course Details</a>
                      </p>
                    </div>
                  } @else if (isCurrentSelectedSessionCovered) {
                    <div class="space-y-2">
                      <a
                        [routerLink]="['/live-classes', selectedLiveClass?.id]"
                        class="daisy-btn daisy-btn-success daisy-btn-block text-base shadow-sm gap-2"
                      >
                        <i class="fa-solid fa-circle-check"></i>
                        <span>
                          @if (currentSelectedSessionAccess.accessType === 'MONTHLY') {
                            Covered by Monthly Plan • Go to Live Class
                          } @else if (currentSelectedSessionAccess.accessType === 'ONE_TIME') {
                            Full Access Active • Go to Live Class
                          } @else {
                            Pass Active • Go to Live Class
                          }
                        </span>
                      </a>
                      <p class="text-xs text-base-content/70 text-center">
                        You already have access to this session. <a [routerLink]="['/live-classes', selectedLiveClass?.id]" class="daisy-link daisy-link-success font-semibold">View Class Details</a>
                      </p>
                    </div>
                  } @else if (selectedPaymentTypeIndex === 0 && hasActiveMonthlySubscription) {
                    <div class="space-y-2">
                      <a
                        [routerLink]="['/live-classes', selectedLiveClass?.id]"
                        class="daisy-btn daisy-btn-success daisy-btn-block text-base shadow-sm gap-2"
                      >
                        <i class="fa-solid fa-circle-check"></i>
                        <span>Current Plan Active • Go to Live Class</span>
                      </a>
                      <p class="text-xs text-base-content/70 text-center">
                        You are already enrolled on Monthly Flexi. <a [routerLink]="['/live-classes', selectedLiveClass?.id]" class="daisy-link daisy-link-success font-semibold">View Class Sessions</a>
                      </p>
                    </div>
                  } @else if (pendingSubscription) {
                    <div class="space-y-2">
                      <button
                        type="button"
                        class="daisy-btn daisy-btn-warning daisy-btn-outline daisy-btn-block text-base cursor-not-allowed"
                        disabled
                      >
                        <i class="fa-solid fa-clock mr-1.5"></i> Payment Already Under Review
                      </button>
                      <p class="text-xs text-base-content/70 text-center">
                        You have a payment pending verification. <a routerLink="/invoices" class="daisy-link daisy-link-primary font-semibold">View Invoices</a>
                      </p>
                    </div>
                  } @else {
                    <button
                      (click)="createSubscription()"
                      class="daisy-btn daisy-btn-primary daisy-btn-block text-base"
                      [disabled]="
                        selectedPaymentTypeIndex === 2 &&
                        upcomingSessions.length === 0
                      "
                    >
                      @if (paymentPlan.cost > 0) {
                        <span
                          ><i class="fa-solid fa-lock mr-1.5"></i>
                          {{
                            selectedPaymentTypeIndex === 1
                              ? (hasActiveMonthlySubscription || existingSinglePasses.length > 0 ? 'Upgrade to Full Access' : 'Proceed to Payment')
                              : (selectedPaymentTypeIndex === 0 && existingSinglePasses.length > 0 ? 'Upgrade to Monthly Flexi' : 'Proceed to Payment')
                          }}</span
                        >
                      } @else {
                        <span
                          ><i class="fa-solid fa-check mr-1.5"></i>
                          {{
                            selectedPaymentTypeIndex === 1
                              ? (hasActiveMonthlySubscription || existingSinglePasses.length > 0 ? 'Upgrade to Full Access for Free' : 'Subscribe for Free')
                              : 'Subscribe for Free'
                          }}</span
                        >
                      }
                    </button>
                  }
                </div>
              }
            </div>
          } @else {
            <div class="daisy-card-body p-6 md:p-8 flex flex-col gap-6 animate-pulse">
              <div class="h-6 bg-base-300 rounded w-1/3"></div>
              <div class="h-20 bg-base-300 rounded-xl"></div>
              <div class="h-20 bg-base-300 rounded-xl"></div>
              <div class="h-28 bg-base-300 rounded-xl"></div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>

  <!-- Calculation Breakdown Modal -->
  <dialog
    class="daisy-modal daisy-modal-bottom sm:daisy-modal-middle"
    [class.daisy-modal-open]="isBreakdownModalOpen"
  >
    <div
      class="daisy-modal-box max-w-2xl bg-base-100 text-base-content border border-base-300 shadow-2xl p-6"
    >
      <div
        class="flex items-center justify-between pb-3 border-b border-base-300"
      >
        <div>
          <h3
            class="font-bold text-lg text-base-content flex items-center gap-2"
          >
            <i class="fa-solid fa-calculator text-primary"></i>
            <span>Calculation Breakdown</span>
          </h3>
          <p class="text-xs text-base-content/70 mt-0.5">
            Detailed fee calculation for each scheduled class type in
            {{ planTitle }}
          </p>
        </div>
        <button
          type="button"
          (click)="closeBreakdownModal()"
          class="daisy-btn daisy-btn-sm daisy-btn-circle daisy-btn-ghost text-base-content/70 hover:text-base-content"
        >
          <i class="fa-solid fa-xmark text-base"></i>
        </button>
      </div>

      <!-- Period Info -->
      <div
        class="my-4 p-3 rounded-lg bg-base-200/60 border border-base-300 flex flex-wrap items-center justify-between gap-2 text-xs"
      >
        <span class="text-base-content/70">
          <span class="font-semibold text-base-content">Access Period:</span>
          {{ selectedPaymentPlanData?.startDate | date: 'mediumDate' }} –
          {{ selectedPaymentPlanData?.endDate | date: 'mediumDate' }}
        </span>
        <span
          class="daisy-badge daisy-badge-outline daisy-badge-sm text-base-content/80"
          >{{ planBadge }}</span
        >
      </div>

      <!-- Breakdown Table -->
      <div class="overflow-x-auto rounded-lg border border-base-300">
        <table
          class="daisy-table daisy-table-zebra w-full text-xs text-base-content"
        >
          <thead class="bg-base-200 text-base-content font-bold">
            <tr>
              <th class="py-2.5">Class / Session Type</th>
              <th class="py-2.5 text-center">Sessions</th>
              <th class="py-2.5 text-right">Rate / Session</th>
              <th class="py-2.5 text-right">Subtotal</th>
            </tr>
          </thead>
          <tbody>
            @for (item of planBreakdownItems; track item.name) {
              <tr
                class="border-b border-base-200"
                [class.bg-success/5]="item.isCredit"
              >
                <td class="py-2.5">
                  <div
                    class="font-semibold text-base-content flex items-center gap-1.5"
                    [class.text-success]="item.isCredit"
                  >
                    @if (item.isCredit) {
                      <i class="fa-solid fa-tag text-xs"></i>
                    }
                    <span>{{ item.name }}</span>
                  </div>
                  <div class="text-[0.7rem] text-base-content/60">
                    {{ item.recurrenceLabel }}
                    @if (item.timeRange) {
                      • {{ item.timeRange }}
                    }
                  </div>
                </td>
                <td
                  class="py-2.5 text-center font-mono font-semibold"
                  [class.text-success]="item.isCredit"
                >
                  {{ item.isCredit ? '-1' : item.sessionCount }}
                </td>
                <td class="py-2.5 text-right">
                  @if (item.isCredit) {
                    <span class="text-success font-semibold"
                      >- LKR {{ -item.pricePerSession | number }}</span
                    >
                  } @else if (item.pricePerSession > 0) {
                    LKR {{ item.pricePerSession | number }}
                  } @else {
                    <span class="text-success font-semibold">Free</span>
                  }
                </td>
                <td class="py-2.5 text-right font-semibold text-base-content">
                  @if (item.isCredit) {
                    <span class="text-success"
                      >- LKR {{ -item.subtotal | number }}</span
                    >
                  } @else if (item.subtotal > 0) {
                    LKR {{ item.subtotal | number }}
                  } @else {
                    <span class="text-success">Free</span>
                  }
                </td>
              </tr>
            } @empty {
              <tr>
                <td colspan="4" class="text-center py-4 text-base-content/60">
                  No scheduled sessions found for this period.
                </td>
              </tr>
            }
          </tbody>
          <tfoot
            class="bg-base-200/80 text-base-content font-bold border-t border-base-300"
          >
            <tr>
              <td>Total</td>
              <td class="text-center font-mono">
                {{ breakdownTotalSessions }}
              </td>
              <td></td>
              <td class="text-right text-sm text-primary">
                @if (breakdownTotalCost > 0) {
                  LKR {{ breakdownTotalCost | number }}
                } @else {
                  <span class="text-success">Free</span>
                }
              </td>
            </tr>
          </tfoot>
        </table>
      </div>

      <div class="daisy-modal-action mt-5">
        <button
          (click)="closeBreakdownModal()"
          class="daisy-btn daisy-btn-primary daisy-btn-sm px-6"
        >
          Close
        </button>
      </div>
    </div>
    <form method="dialog" class="daisy-modal-backdrop">
      <button (click)="closeBreakdownModal()">close</button>
    </form>
  </dialog>
</div>
